export default __webpack_public_path__ + "static/media/bg.490af011.png";